import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../App';
import { exchangeCodeForTokens, decodeIdToken } from '../utils/oidc';
import api from '../utils/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(UserContext);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const domain = (typeof window !== 'undefined' && window.__COGNITO_DOMAIN__) || process.env.REACT_APP_COGNITO_DOMAIN || '';
        const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
        const redirectUri = window.location.origin + '/auth/callback';
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (!domain || !clientId || !code) {
          setError('Missing OAuth parameters');
          return;
        }
        const codeVerifier = sessionStorage.getItem('pkce_verifier') || '';
        const tokens = await exchangeCodeForTokens({ domain, clientId, code, redirectUri, codeVerifier });
        const idPayload = decodeIdToken(tokens.id_token || '');
        if (!idPayload) {
          setError('Invalid id_token');
          return;
        }
        const currentUser = {
          id: String(idPayload.sub || ''),
          email: String(idPayload.email || ''),
          name: String(idPayload.name || `${idPayload.given_name || ''} ${idPayload.family_name || ''}`.trim()),
          role: 'owner',
          type: 'owner',
          idToken: tokens.id_token,
          accessToken: tokens.access_token || ''
        };
        setCurrentUser(currentUser);
        try { localStorage.setItem('currentUser', JSON.stringify(currentUser)); } catch {}
        // Optionally enrich from backend
        try {
          const me = await api.get('/auth/me', { params: { email: currentUser.email } });
          const enriched = { ...currentUser, role: me.data.role || currentUser.role, type: me.data.activeContext || currentUser.type, name: me.data.name || currentUser.name };
          setCurrentUser(enriched);
          try { localStorage.setItem('currentUser', JSON.stringify(enriched)); } catch {}
        } catch {}
        navigate('/dashboard');
      } catch (e) {
        setError('Authentication failed');
      }
    })();
  }, [navigate, setCurrentUser]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {error ? <div>{error}</div> : <div>Signing you in…</div>}
    </div>
  );
}


